import { createReducer } from '@reduxjs/toolkit';

import { dialogClosed, dialogOpened } from 'Core/actions/dialog';
import {
  forceVehicleSelection,
  forceVehicleSelectionLater,
  garageCleanupRequested,
  removalFromGarageRequested,
  replaceVehicleValue,
  setFitmentTableResponse,
  vehicleDiscardingRequested,
  vehicleSelected,
  vehicleSpecificationNeeded,
} from 'Core/actions/fitmentSearch/index';
import { resetRequest } from 'Core/actions/request';
import { setResponse } from 'Core/actions/response';
import { getVehicleFromUri } from 'Modules/converter/index';
import type { ServerModel } from 'Modules/serverApi/types';

const initVehicleFromUriSelection = getVehicleFromUri().selection;

export default {
  isPageLoadedWithVehicleInUri: createReducer(initVehicleFromUriSelection.length > 0, () => {}),
  isSpecifyDialogOpened: createReducer(false, (builder) =>
    builder
      .addCase(dialogClosed, () => false)
      .addCase(vehicleSelected, () => false)
      .addCase(vehicleSpecificationNeeded, () => true),
  ),
  isVehicleSelectionForced: createReducer(false, (builder) =>
    builder
      .addCase(forceVehicleSelection, () => true)
      .addCase(forceVehicleSelectionLater, () => false)
      .addCase(vehicleSelected, () => false),
  ),
  fitmentTableResponse: createReducer<ServerModel.FitmentsResponse | null>(null, (builder) =>
    builder.addCase(setFitmentTableResponse, (_, { payload }) => payload),
  ),
  showDialog: createReducer(false, (builder) =>
    builder
      .addCase(dialogOpened, (state, { payload }) => payload === 'VehicleWidgetDialog' || state)
      .addCase(dialogClosed, (state, { payload }) => (payload === 'VehicleWidgetDialog' ? false : state))
      .addCase(forceVehicleSelection, () => true)
      .addCase(vehicleSelected, () => false)
      .addCase(
        vehicleSpecificationNeeded,
        (state, { meta: { isolatedKey } }) => isolatedKey === null || state,
      ),
  ),
  vehicleFromUri: createReducer(initVehicleFromUriSelection, (builder) =>
    builder
      .addCase(setResponse, (state) => (state.length ? getVehicleFromUri().selection : []))
      .addCase(vehicleSelected, () => [])
      .addCase(vehicleDiscardingRequested, () => [])
      .addCase(replaceVehicleValue, () => [])
      .addCase(removalFromGarageRequested, (state, { meta }) => (meta.wasSelected ? [] : state))
      .addCase(garageCleanupRequested, () => [])
      .addCase(resetRequest, () => []),
  ),
};
